import type { TenantDefinition } from "../types";
import cdcr from "./cdcr";
import defaultTenant from "./default";
import tu from "./tu";

export const tenants: Record<string, TenantDefinition> & {
	default: TenantDefinition;
} = {
	default: defaultTenant,
	tu,
	cdcr,
};
